<template>
  <div id="app">
    <HeaderView
      v-if="currentRouteName != 'lineitem' && currentRouteName != 'test'"
    />
    <router-view />
    <FooterView
      v-if="currentRouteName != 'lineitem' && currentRouteName != 'test'"
    />
  </div>
</template>
<script>
import HeaderView from "@/components/HeaderView.vue";
import FooterView from "@/components/FooterView.vue";
export default {
  name: "header-view",
  components: {
    HeaderView,
    FooterView,
  },
  mounted() {
    if (this.$route.query.code) {
      window.code = this.$route.query.code;
    }
    this.setStats();
  },
  methods: {
    setStats() {
      const scriptElement = document.createElement("script");
      scriptElement.async = true;
      scriptElement.defer = true;
      scriptElement.src = "https://eu.umami.is/script.js";
      scriptElement.dataset.websiteId = '2bb95af9-3a89-49b9-a933-946a092f9e7c';
      scriptElement.dataset.doNotTrack = "true";
      scriptElement.dataset.autoTrack = "true";

      // Récupérer code_unique depuis l'URL originale (avant redirections du router)
      const urlParams = new URLSearchParams(window.location.search);
      const codeUnique = urlParams.get('code_unique');
      if (codeUnique) {
        scriptElement.dataset.tag = codeUnique;
      }

      document.body.append(scriptElement);
    },
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    currentPath() {
      return this.$route.path;
    },
  },
};
</script>
